import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from 'src/datasources';
import Errors from 'components/base/errors';
import * as actions from './actions.js';
import Edit from './edit';

class Container extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <Errors errors={this.props.errors} onError={this.props.actions.error} />
        {this.props.agent ? (
          <Edit agent={this.props.agent} actions={this.props.actions} />
        ) : (
          <div />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    agents: state.agents,
    agent: state.agent,
    kintoneSettings: state.kintoneSettings,
    errors: state.errors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Container);
